import { Injectable } from '@angular/core';
import { ForfettappApiClient } from '@shared/forfettapp-api-client';
import { BehaviorSubject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { StatoSituazioneDebitoria } from '../agenzia-entrate-riscossione/agenzia-entrate-riscossione.models';
import { CodiceTributo, Credito, CreditoConSaldo, CreditoUtilizzato } from './crediti.models';

@Injectable({
    providedIn: 'root',
})
export class CreditiService {
    private _statoSituazioneDebitoria: BehaviorSubject<StatoSituazioneDebitoria | null> = new BehaviorSubject<StatoSituazioneDebitoria | null>(null);
    private _creditiConSaldo: BehaviorSubject<CreditoConSaldo[] | null> = new BehaviorSubject<CreditoConSaldo[] | null>(null);

    constructor(private service: ForfettappApiClient) {}

    get statoSituazioneDebitoria$() {
        return this._statoSituazioneDebitoria.asObservable().pipe(filter(stato => !!stato));
    }

    get creditiConSaldo$() {
        return this._creditiConSaldo.asObservable().pipe(filter(crediti => !!crediti));
    }

    set statoSituazioneDebitoria(value: StatoSituazioneDebitoria | null) {
        this._statoSituazioneDebitoria.next(value);
    }

    set creditiConSaldo(value: CreditoConSaldo[] | null) {
        this._creditiConSaldo.next(value);
    }

    getCreditiConSaldo(codiceFiscale: string) {
        return this.service
            .get<CreditoConSaldo[]>(`/backoffice/contribuente/${codiceFiscale}/crediti`)
            .pipe(tap(creditiConSaldo => (this.creditiConSaldo = creditiConSaldo)));
    }

    getStatoSituazioneDebitoria(codiceFiscale: string) {
        return this.service
            .get<StatoSituazioneDebitoria>(`/backoffice/contribuente/${codiceFiscale}/crediti/situazione-debitoria`)
            .pipe(tap(statoSituazioneDebitoria => (this.statoSituazioneDebitoria = statoSituazioneDebitoria)));
    }

    getCredito(codiceFiscale: string, creditoId: number) {
        return this.service.get<Credito>(`/backoffice/contribuente/${codiceFiscale}/crediti/${creditoId}`);
    }

    getDettagliCredito(codiceFiscale: string, creditoId: number) {
        return this.service.get<CreditoUtilizzato[]>(`/backoffice/contribuente/${codiceFiscale}/crediti/${creditoId}/dettagli`);
    }

    getCodiciTributi() {
        return this.service.get<CodiceTributo[]>(`/backoffice/codici-tributi`);
    }

    addCredito(codiceFiscale: string, credito: Credito) {
        console.warn('codiceFiscale', codiceFiscale);
        return this.service.post<Credito>(`/backoffice/contribuente/${codiceFiscale}/crediti`, credito);
    }

    updateCredito(codiceFiscale: string, credito: Credito) {
        return this.service.post<Credito>(`/backoffice/contribuente/${codiceFiscale}/crediti/${credito.id}`, credito);
    }

    deleteCredito(codiceFiscale: string, creditoId: number) {
        return this.service.delete(`/backoffice/contribuente/${codiceFiscale}/crediti/${creditoId}`);
    }
}
